import { render, staticRenderFns } from "./PendingSwapsList.vue?vue&type=template&id=5d6524c8&scoped=true&"
import script from "./PendingSwapsList.vue?vue&type=script&lang=ts&"
export * from "./PendingSwapsList.vue?vue&type=script&lang=ts&"
import style0 from "./PendingSwapsList.vue?vue&type=style&index=0&id=5d6524c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6524c8",
  null
  
)

export default component.exports